import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
	useGetRGAFromLatLon,
	useGetSismicFromLatLon,
} from "../../../api/queries/georisques.queries";
import AddressFormFields from "../../shared/AddressFormFields";

const AddressDetailsContainer = () => {
	const { setValue } = useFormContext();
	const [latlon, setLatlon] = useState("");

	const { refetch: refetchRGA } = useGetRGAFromLatLon(latlon);
	const { refetch: refetchSismic } = useGetSismicFromLatLon(latlon);

	const handleGeolocationChange = (newLatlon: string) => {
		setLatlon(newLatlon);
		setValue("latlon", newLatlon);
	};

	useEffect(() => {
		const fetchData = async () => {
			if (latlon) {
				const { data: rgaData } = await refetchRGA();
				const { data: sismicData } = await refetchSismic();
				!Number.isNaN(Number(rgaData?.codeExposition))
					? setValue("rga", Number(rgaData?.codeExposition))
					: setValue("rga", undefined);
				!Number.isNaN(Number(sismicData?.code_zone - 1))
					? setValue("sismic", Number(sismicData?.code_zone - 1))
					: setValue("sismic", undefined);
			}
		};
		fetchData();
	}, [latlon, refetchRGA, refetchSismic, setValue]);

	return (
		<AddressFormFields
			showBorder={true}
			onGeolocationChange={handleGeolocationChange}
			includeGeolocation={true}
		/>
	);
};

export default AddressDetailsContainer;
